export const ROUTE_SECURITY = '/security';

export const ROUTE_APPROVAL_RULES = `${ROUTE_SECURITY}/approval-rules`;

// Default consensus 2FA type for newly created approval rules
export const DEFAULT_CONSENSUS_2FA_TYPE = 'ORG_DEFAULT';

// Org resource type, used for org-level rules and actions
export const ORG_SCOPED_RESOURCE_TYPE = 'account_management/organization';
